import { IconButton, TableCell, TableRow, Tooltip } from "@material-ui/core";

import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ExtensionIcon from "@material-ui/icons/Extension";
import { useLogin } from "../../../../context/LoginContext";
import { useSistema } from "../../../../context/SistemaContext";
import { useStyle } from "../../../../context/StyleContext";

export default function Boton(props) {
    const { boton } = props;

    const { classes } = useStyle();
    const { usuarioPermisos } = useLogin();
    const { handleClickEditarBoton, handleClickEliminarBoton } = useSistema();

    const colorClass = "color-3";
    const permisos = usuarioPermisos["1"].Submodulos["3"];

    return (
        <TableRow>
            <TableCell classes={{ sizeSmall: classes.cellButton }} align="left">
                <ExtensionIcon className={colorClass + " vertical-align-middle"} />
                <span className={colorClass + " size-15"}>
                    {boton.sNombre} ({boton.iIdBoton})
                </span>
            </TableCell>
            <TableCell classes={{ sizeSmall: classes.cellButton }} align="right">
                {permisos.Botones["9"] !== undefined && ( //Editar el botón
                    <Tooltip title={`${permisos.Botones["9"].Nombre} ${boton.sNombre}`} placement="top" arrow>
                        <IconButton onClick={(e) => handleClickEditarBoton(e, boton)}>
                            <EditIcon />
                        </IconButton>
                    </Tooltip>
                )}
                {permisos.Botones["10"] !== undefined && ( //Eliminar el botón
                    <Tooltip title={`${permisos.Botones["10"].Nombre} ${boton.sNombre}`} placement="top" arrow>
                        <IconButton onClick={(e) => handleClickEliminarBoton(e, boton)}>
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                )}
            </TableCell>
        </TableRow>
    );
}
